module.exports = __webpack_public_path__ + "img/claudecode.8542caa1.svg";